import { Option } from 'shared/components/OptionsWithInput/Option';
import { getCurrencyConfig } from '@okletsplay/core';
import {
  convertCryptoToUsd,
  formatFiat,
  formatCrypto,
  calculatePlatformFeeFromPrimaryAmount,
  HIGH_FORMAT_CURRENCY_PRECISION,
} from 'shared/utils';
import { MultiCurrencyConfig } from 'config/multi-currency-config';

const FREE_OPTION: Option = { label: 'Free', value: 0 };

const OKLP_AMOUNTS = [5, 10, 25, 50, 100];

const convertAndFormatFiat = (cryptoAmount: number, exchangeRate: number) => {
  const fiatAmount = convertCryptoToUsd(cryptoAmount, exchangeRate);

  return `(${formatFiat(fiatAmount)})`;
};

export const getOklpEntryAmountOptions = (exchangeRate: number): Option[] => {
  const options = OKLP_AMOUNTS.map(
    (value) =>
      ({
        value,
        label: formatCrypto(value),
        subLabel: convertAndFormatFiat(value, exchangeRate),
      } as Option)
  );

  options.unshift(FREE_OPTION);

  return options;
};

const MAIN_CURRENCY_AMOUNTS = [0.1, 0.5, 1, 2, 5];

const currencyConfig = getCurrencyConfig(MultiCurrencyConfig.currencyType());

export const getEntryAmountOptions = (
  exchangeRate: number,
  platformFeePercentage: number
): Option[] => {
  if (!currencyConfig) {
    return [];
  }
  const options = MAIN_CURRENCY_AMOUNTS.map((value) => {
    const platformFee = formatCrypto(
      calculatePlatformFeeFromPrimaryAmount(value, exchangeRate, platformFeePercentage),
      currencyConfig?.platformFee,
      HIGH_FORMAT_CURRENCY_PRECISION
    );

    return {
      value,
      label: formatCrypto(value, currencyConfig.main, HIGH_FORMAT_CURRENCY_PRECISION),
      subLabel: `+ ${platformFee}`,
    } as Option;
  });

  options.unshift(FREE_OPTION);

  return options;
};
